import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";

const API_ENDPOINT = import.meta.env.VITE_API_ENDPOINT;

const defaultHeaders = {
  "Content-Type": "application/json",
  "Cache-Control": "no-cache",
};

// Create an instance of axios with default settings
const axiosInstance: AxiosInstance = axios.create({
  baseURL: API_ENDPOINT, // Set your base URL here
  // timeout: 10000, // Set a timeout for requests
  headers: defaultHeaders,
});

// Function to handle GET requests
export const fetcher = async <T>(
  method: "GET" | "POST" | "PUT" | "DELETE" | "PATCH",
  url: string,
  data: any = null,
  params: Record<string, any> | null = null,
  customHeaders: Record<string, any> | null = null,
  withCredentials: boolean = false,
): Promise<T> => {
  try {
    const combinedHeaders = {
      ...axiosInstance.defaults.headers.common,
      ...defaultHeaders,
      ...customHeaders,
    };

    const config: AxiosRequestConfig = {
      method,
      url,
      params,
      headers: combinedHeaders,
    };

    if (withCredentials) {
      config.withCredentials = withCredentials;
    }

    if (data) {
      config.data = data;
    }

    const response: AxiosResponse<T> = await axiosInstance.request(config);
    return response.data;
  } catch (error) {
    console.error("Request error:", error);
    throw error;
  }
};
